import { render, staticRenderFns } from "./recordPickingProducts.vue?vue&type=template&id=5c5328a8&scoped=true"
import script from "./recordPickingProducts.vue?vue&type=script&lang=js"
export * from "./recordPickingProducts.vue?vue&type=script&lang=js"
import style0 from "./recordPickingProducts.vue?vue&type=style&index=0&id=5c5328a8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5328a8",
  null
  
)

export default component.exports